import styled from 'styled-components'

export const ComponentStructure = styled.div`
  width: 32px;
  position: absolute;
  top: 8px;
  right: 8px;
`
